import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
import MdmStripe from '~/components/atoms/Global/MdmStripe.vue';
export default {
  name: 'StickerDecoration',
  components: {
    MdmStripe: MdmStripe
  },
  props: {
    trend: {
      type: Object,
      required: true
    },
    size: {
      type: MdmStripe.props.size.type,
      default: MdmStripe.props.size.default,
      validator: MdmStripe.props.size.validator
    }
  }
};